import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.number.constructor.js";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";
import { useNavigationStore } from "../hooks/NavigationContext";
import { useSelfServeContextStore } from "../hooks/SelfServeContext";
import { SelfServeHeader } from "./components/SelfServeHeader";
import { SelfServeProgressBar } from "./components/SelfServeProgressBar";
import { TOTAL_3_STEPS, TOTAL_4_STEPS } from "./step";
export var SelfServeSkeleton = function SelfServeSkeleton(_ref) {
  var children = _ref.children;
  var _useNavigationStore = useNavigationStore(["currentStep"]),
    _useNavigationStore2 = _slicedToArray(_useNavigationStore, 1),
    currentStep = _useNavigationStore2[0].currentStep;
  var _useSelfServeContextS = useSelfServeContextStore(["brandOrders"]),
    _useSelfServeContextS2 = _slicedToArray(_useSelfServeContextS, 1),
    brandOrders = _useSelfServeContextS2[0].brandOrders;
  var currentStepNumber = Number(currentStep);
  var TOTAL_STEPS = brandOrders && brandOrders.length > 0 ? TOTAL_4_STEPS : TOTAL_3_STEPS;
  var progressNumber = Math.floor(currentStepNumber / TOTAL_STEPS * 100);
  return /*#__PURE__*/React.createElement(SelfServeSkeletonWrapper, {
    "data-test-id": "self-serve-wrapper"
  }, /*#__PURE__*/React.createElement(SelfServeHeader, {
    issueType: ""
  }), /*#__PURE__*/React.createElement(SelfServeProgressBar, {
    progress: progressNumber
  }), /*#__PURE__*/React.createElement(ContentWrapper, {
    "data-test-id": "content-wrapper"
  }, /*#__PURE__*/React.createElement(Center, null, children)));
};
var SelfServeSkeletonWrapper = styled(Column).withConfig({
  displayName: "SelfServeSkeleton__SelfServeSkeletonWrapper"
})(["width:100%;background-color:transparent;height:auto;min-height:100vh;"]);
var ContentWrapper = styled(Column).attrs({
  align: "center",
  justify: "center"
}).withConfig({
  displayName: "SelfServeSkeleton__ContentWrapper"
})(["width:100%;height:100%;padding:", ";", "{padding:", ";}> *{width:100%;}"], getSpacing("1x", "2x"), responsiveMediaQueries.mobile, getSpacing("1x"));
var Center = styled(Column).attrs({
  justify: "center"
}).withConfig({
  displayName: "SelfServeSkeleton__Center"
})(["max-width:1168px;"]);